import Vue from 'vue'
import autosize from 'autosize'

export const textautosize = {
  bind (el) {
    Vue.nextTick(() => {
      autosize(el)
    })
  },
  unbind (el) {
    autosize.destroy(el)
  },
}

export const focus = {
  inserted (el) {
    el.focus()
  },
}

export const select = {
  inserted (el) {
    el.select()
  },
}



// WEBPACK FOOTER //
// ./src/directives.js